<div class="my-5">
  <sm-page-header [title]="'dac.title' | translate" [breadcrumb]="breadcrumb"></sm-page-header>
  <sm-dac-inspect-content-block [id]="id" [version]="version" [setBreadcrumbElement]="setBreadcrumbElement.bind(this)"></sm-dac-inspect-content-block>
</div>
